<template>
    <div class="body">
        <!-- <div class="search">
            <input placeholder="请输入问题，AI搜索" />
            <img src="../../assets/img/i16.png" />
        </div> -->
        <div class="label">
            <div class="l_item" :class="typeIndex == index ? 'li' : ''" v-for="(item, index) in typeList" :key="index"
                @click="btn_type(index)">{{ item.label }}</div>
        </div>
        <div class="tab">
            <div class="t_item" :class="lIndex == index ? 'ti' : ''" v-for="(item, index) in labelList" :key="index"
                @click="btn_label(item, index)" v-if="item.labelGroup">
                {{ item.labelGroup }}
                <div class="ti_line" v-if="lIndex == index"></div>
            </div>
        </div>
        <div class="list">
            <div class="item" :title="item.note" :style="{ backgroundColor: item.backgroundColor }"
                v-for="(item, index) in bottomList" :key="index" @click="btn_item(item)">
                <div class="i_top">
                    <img :src="webImg + item.icon" />
                    <div class="line1_">{{ item.name }}</div>
                </div>
                <div class="i_bottom line2_">{{ item.note }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { helperListAll, helperLabelId } from '@/apis/index'
export default {
    data() {
        return {
            list: [],
            topList: [],
            typeList: [],
            bottomList: [],
            typeIndex: 0,
            flag: false,
            labelId: '',
            labelList: [],
            lIndex: 0,
            obj: {},
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        btn_item(item) {
            console.log(item, 'item');
            var obj = item
            delete obj.prompt
            this.$router.push({ path: '/callWord', query: { item: encodeURIComponent(JSON.stringify(obj))} })
        },
        btn_label(item, index) {
            this.lIndex = index
            this.bottomList = item.helperList
            console.log(item, 'item');
        },
        btn_type(index) {
            this.typeIndex = index
            this.labelId = this.typeList[index].labelId
            this.lIndex = 0
            this.getList()
        },
        getHelperLabelId() {
            helperLabelId(this.labelId).then(res => {
                console.log(res, 'helperLabelId');
                this.labelList = res.data
                if (this.obj && this.obj.childId) {
                    this.lIndex = this.labelList.findIndex((item) => item.labelId == this.obj.childId)
                    this.obj = {}
                }
                this.bottomList = this.labelList[this.lIndex].helperList
            })
        },
        getList() {
            helperListAll(1).then(res => {
                console.log(res, 'helperListAll');
                this.typeList = res.data
                if (this.obj && this.obj.parentId) {
                    this.labelId = this.obj.parentId
                    this.typeIndex = this.typeList.findIndex((item) => item.labelId == this.obj.parentId)
                    console.log(this.typeIndex, 'typeIndex', this.obj);
                }
                if (this.labelId == '' || this.labelId == null || this.labelId == undefined) {
                    this.labelId = this.typeList[0].labelId
                }
                this.obj.parentId = ''
                this.getHelperLabelId()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.body {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .search {
        width: 700px;
        height: 50px;
        background: #FFFFFF;
        box-shadow: 0px 7px 6px 0px rgba(0, 0, 0, 0.05);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #E9EBF2;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 30px;
        margin-top: 20px;

        input {
            flex: 1;
            margin-right: 30px;
            font-size: 16px;
        }

        img {
            width: 20px;
            height: 20px;
        }
    }

    .label {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0;

        .li {
            background: #2992FF !important;
            color: #FFFFFF !important;
        }

        .l_item {
            width: fit-content;
            height: 34px;
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #E9EBF2;
            box-sizing: border-box;
            padding: 0 25px;
            line-height: 34px;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            cursor: pointer;
            margin: 0 5px;
        }
    }

    .tab {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .ti {
            color: #2992FF !important;
        }

        .t_item {
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0 30px;
            cursor: pointer;

            .ti_line {
                position: absolute;
                bottom: -6px;
                width: 16px;
                height: 2px;
                background: #2992FF;
                border-radius: 2px 2px 2px 2px;
            }
        }
    }

    .list::-webkit-scrollbar {
        display: none;
    }

    .list {
        flex: 1;
        width: 100%;
        height: 0;
        display: flex;
        align-items: center;
        align-content: flex-start;
        flex-wrap: wrap;
        margin-top: 45px;
        overflow-y: scroll;
        margin-bottom: 20px;

        .item:nth-child(4n) {
            margin-right: 0 !important;
        }

        .item {
            width: 281px;
            // height: 130px;
            background: #FDF8F8;
            border-radius: 10px 10px 10px 10px;
            border: 2px solid #FFFFFF;
            box-sizing: border-box;
            padding: 20px;
            margin-right: 25px;
            margin-bottom: 25px;
            cursor: pointer;
            // box-shadow: 0px 2px 24px 0px rgba(190,198,204,0.25);
            box-shadow: 0px 7px 6px 0px rgba(0, 0, 0, 0.05);

            .i_top {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                img {
                    width: 36px;
                    height: 36px;
                }

                div {
                    flex: 1;
                    margin-left: 10px;
                    font-weight: bold;
                    font-size: 18px;
                    color: #000000;
                }
            }

            .i_bottom {
                width: 100%;
                height: 45px;
                font-weight: 300;
                font-size: 14px;
                color: #949494;
                line-height: 22px;
            }
        }
    }
}
</style>